import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Journey, JourneyStatus } from '@interfaces/journey';
import { TripParams } from '@interfaces/trip-params';
import { User } from '@interfaces/user';
import { ModalController } from '@ionic/angular';
import { JourneyWatchService } from '@services/journey-watch.service';
import { RestService } from '@services/rest.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-preparing-trip',
  templateUrl: './preparing-trip.component.html',
  styleUrls: ['./preparing-trip.component.scss'],
})
export class PreparingTripComponent implements OnInit, OnDestroy {
  @Input() isModal = false;
  @Output() openServiceEvent = new EventEmitter<void>();
  private journeySubscription!: Subscription | null;

  tripParams!: TripParams;
  journeyStatus!: JourneyStatus;
  currentJourney?: Journey;
  currentQueue = 0;
  // private intervalId: any;

  constructor(
    private modalController: ModalController,
    private journeyWatchService: JourneyWatchService,
    private rest: RestService,
    private cd: ChangeDetectorRef
  ) {
    this.journeySubscription = this.journeyWatchService.getJourneyCurrentObserable().subscribe(async (currentJourney) => {
      let currentUser: User;
      const result = await this.rest.getCurrentUser();
      if (result) {
        currentUser = result;
        // this.clearIntervalJourney();
        console.log('currentJourney', currentJourney);
        if (currentJourney && !currentUser.role?.includes('client-hotel')) {
          if (currentJourney.queue && (this.currentQueue === 0 || (this.currentQueue > (currentJourney.queue || 0)))) {
            this.currentQueue = currentJourney.queue || 0;
            this.cd.detectChanges();
          }
          this.checkJourneyStatus(currentJourney);
        }
        if (!currentJourney) {
          this.modalController.dismiss();
        }
      }
    })
  }

  ngOnInit() {
    this.currentQueue = 0;
    if (!this.journeyStatus) {
      this.journeyStatus = 'NEW';
      this.nextStep(this.journeyStatus)
    }
  }

  ngOnDestroy(): void {
    this.journeySubscription?.unsubscribe();
  }

  // async getCurrentJourney() {
  //   const result = await this.rest.getCurrentJourney();
  //   if (result.ok) {
  //     this.checkJourneyStatus(result.response);
  //   }
  // }

  checkJourneyStatus(currentJourney: Journey) {
    this.currentJourney = currentJourney;
    this.journeyStatus = this.currentJourney.status;
    if (['NEW', 'DRIVER_SEARCHING', 'DRIVER_FOUND', 'DRIVER_CONFIRMED', 'PENDING'].includes(this.journeyStatus)) {
      this.nextStep(this.journeyStatus);
    }
  }

  nextStep(journeyStatus: JourneyStatus) {
    if (journeyStatus === 'NEW') {
      this.startNewJourney();
    } else if (journeyStatus === 'DRIVER_CONFIRMED' || journeyStatus === 'PENDING') {
      this.handleDriverConfirmed();
    }
  }

  startNewJourney() {
    setTimeout(() => {
      if (this.journeyStatus === 'NEW') {
        this.journeyStatus = 'DRIVER_SEARCHING';
      }
    }, 3000);
  }

  async handleDriverConfirmed() {
    this.journeySubscription?.unsubscribe();
    if (this.currentJourney) {
      this.journeyWatchService.nextJourney(this.currentJourney);
    }
    console.log('await this.modalController.getTop()', await this.modalController.getTop());
    await this.modalController.dismiss('DRIVER_CONFIRMED');
  }

  async cancelService() {
    await this.modalController.dismiss();
  }

  async openService() {
    this.openServiceEvent.emit();
  }


}
